export const bscTestnetAddresses = {
  TRAVA_TOKEN_ADDRESS: "0x4abef176f22b9a71b45ddc6c4a115095d8761b37",
  RENT_CONTRACT_ADDRESS: "0x8B5B5ac9edc23C1f946d72b74E0eB2D7f6dA36E4",
  KAWAII_CORE_ADDRESS: "0xc12eD27AA3d3A20d7474518a9bB3587EcEE367E3",
  KAWAII_PROXY_CONTRACT_ADDRESS: "0xbc5360e48D8c912E9955caFD7E599645f12104B0",
  MULTI_CALL_ADDRESS: "0xd808400FbF312ACA5C7487cd30B0D1386e04BC78",
  TOKEN_FAUCET_ADDRESS: "0x7B2E3267099f7CB93353cE146Eb22AcEFb02c3Eb",
  TRAVA_AIRDROP_ADDRESS: "",
  KAWAII_AIRDROP_ADDRESS: "",
  KAWAII_TOKEN_ADDRESS: "",

  NFT_CORE_ADDRESS: "0xd2Eca5a421db7c2e2aC88Da684214B52915A66b3",
  NFT_MANAGER_ADDRESS: "0xA91A365D2e3D280553E96D5afA157e6A3e50890A",
  NFT_COLLECTION_ADDRESS: "0x1B9356df6b10Ed01752F6361C8c0a982C99b8cA4",
  NFT_SELL_ADDRESS: "0xf5804062c93b0C725e277F772b5DA06749005cd5",
  NFT_BUY_ADDRESS: "0x105ED6BFdeB0af864714c09cFaD776eB39001e7D",
  NFT_SELL_COLLECTION_ADDRESS: "0x74D65Fe6103cCcC7b69A36BcED852ef00249c880",
  GIVEAWAY_ADDRESS: "0xc76c614c2Ebc3187860F7BcE2c02739C68b84424",
  NFT_TRANSMUTATION_ADDRESS: "0xC02624a76B634518E6F35384aA74b025d12099f2",
  NFT_AUCTION_ADDRESS: "0x72a4F59F3Da3B4e228B33A1E0a625e8492Bae767",
};
